import React from 'react';
import { FaExclamationTriangle, FaFilm, FaCheckCircle, FaUndo } from 'react-icons/fa';

const GRID = 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 sm:gap-6';

export const FeedSkeletonGrid = ({ count = 12, className = GRID }) => (
  <div className={className} aria-hidden="true">
    {Array.from({ length: count }).map((_, idx) => (
      <div key={idx} className="flex flex-col gap-2">
        <div className="w-full aspect-[2/3] bg-dark-700 rounded-xl shimmer" />
        <div className="h-4 bg-white/10 rounded w-3/4 animate-pulse" />
        <div className="h-3 bg-white/10 rounded w-1/3 animate-pulse" />
      </div>
    ))}
  </div>
);

export const FeedErrorState = ({ error, onRetry }) => (
  <div
    role="alert"
    className="text-center py-14 bg-dark-800/60 rounded-3xl border border-red-500/20 p-8"
  >
    <FaExclamationTriangle className="w-10 h-10 text-red-400 mx-auto mb-3" aria-hidden="true" />
    <h3 className="text-lg font-bold text-white mb-1">Could not load content</h3>
    <p className="text-gray-400 text-xs sm:text-sm max-w-md mx-auto mb-6 leading-relaxed">
      {error && error.message ? error.message : 'The TMDB request failed. Please try again.'}
    </p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className="inline-flex items-center gap-2 bg-accent-gold hover:bg-accent-goldHover text-dark-900 font-extrabold text-xs px-6 py-2.5 rounded-xl transition-all shadow-md"
      >
        <FaUndo className="w-3 h-3" aria-hidden="true" />
        <span>Try Again</span>
      </button>
    )}
  </div>
);

export const FeedEmptyState = ({ title, description, action }) => (
  <div className="text-center py-14 bg-dark-800/40 rounded-3xl border border-white/5 p-8">
    <FaFilm className="w-10 h-10 text-gray-600 mx-auto mb-3" aria-hidden="true" />
    <h3 className="text-lg font-bold text-white mb-1">{title}</h3>
    <p className="text-gray-400 text-xs sm:text-sm max-w-md mx-auto leading-relaxed">{description}</p>
    {action && <div className="mt-6">{action}</div>}
  </div>
);

export const FeedEndState = ({ totalResults, noun = 'titles' }) => (
  <p className="text-center text-xs text-gray-500 pt-10 pb-2 flex items-center justify-center gap-2">
    <FaCheckCircle className="text-accent-gold/70 w-3.5 h-3.5" aria-hidden="true" />
    <span>
      {totalResults > 0
        ? `You have reached the end of all ${totalResults.toLocaleString()} ${noun}.`
        : `You have reached the end of the catalog.`}
    </span>
  </p>
);

export { GRID as FEED_GRID };
